import '../../client/index.js';
import { wrapErrorManager } from '../../utils/error-manager.js';
import { transformCmsStorelocatorResponse, transformCmsStorelocatorsResponse, transformUpsapStoresResponse } from './transformers.js';
import defaultClient from 'axios';

const getCmsStorelocator = async ({ client , controller , id  } = {})=>await client.get(`V1/cms/storelocators/${id}`, {
        signal: controller?.signal,
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCmsStorelocatorResponse)
        ]
    });
getCmsStorelocator.key = 'getCmsStorelocator';
const getCmsStorelocators = async ({ client , controller , sku , fields ={} , where ={} , order =[] , limit =1000000 , offset =0 , skip =0  } = {})=>await client.get('V1/cms/storelocators' + (sku ? '?sku=' + sku : ''), {
        signal: controller?.signal,
        params: {
            filter: {
                fields,
                where,
                order,
                limit,
                offset,
                skip
            }
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformCmsStorelocatorsResponse)
        ]
    });
getCmsStorelocators.key = 'getCmsStorelocators';
const postCrmCustomerMeOrdersPickupinstoreConfirm = async ({ client , controller , hash  } = {})=>await client.post(`V1/crm/customer/me/orders/pickupinstore/confirm`, {
        hash
    }, {
        signal: controller?.signal
    });
postCrmCustomerMeOrdersPickupinstoreConfirm.key = 'postCrmCustomerMeOrdersPickupinstoreConfirm';
const postCrmCustomerMeOrdersPickupinstoreReceived = async ({ client , controller , hash  } = {})=>await client.post(`V1/crm/customer/me/orders/pickupinstore/received`, {
        hash
    }, {
        signal: controller?.signal
    });
postCrmCustomerMeOrdersPickupinstoreReceived.key = 'postCrmCustomerMeOrdersPickupinstoreReceived';
const getUpsapStores = async ({ client , controller , countryCode , postCode , city  } = {})=>await client.get(`V1/ups/pudo/locations`, {
        signal: controller?.signal,
        params: {
            country_code: countryCode,
            postal_code: postCode,
            city
        },
        transformResponse: [
            ...(client || defaultClient).defaults.transformResponse,
            wrapErrorManager(transformUpsapStoresResponse)
        ]
    });

export { getCmsStorelocator, getCmsStorelocators, getUpsapStores, postCrmCustomerMeOrdersPickupinstoreConfirm, postCrmCustomerMeOrdersPickupinstoreReceived };
